import { useBusinessModalContext as e } from "../../../BusinessModalContext.js";
const o = "org_id", n = () => {
  const {
    preFilters: r
  } = e(), t = r?.searchOrg;
  return {
    [o]: t
  };
};
export {
  n as useGetOrganization
};
